import { type IEngineSection } from '../../../schema/sections/IEngineSection.ts';
import { hasCode } from '../../../schema/widgets/ICodeWidget.ts';
import { WidgetType } from '../../../schema/widgets/Widget.ts';
import { TreeNavigatorLogic } from '../../../tree/navigation/TreeNavigatorLogic.ts';
import { getWidgetPath } from '../getWidgetPath.ts';

/**
 * Scansiona i widget del modulo e raggruppa i path RHF per tag semantico.
 *
 * Ritorna `semanticTagId -> rhfPath[]`.
 *
 * Qui non viene deciso se un tag è davvero univoco: quella informazione arriva
 * dal catalogo runtime (`context.semanticTags`). Questa funzione legge solo la
 * configurazione widget, dove `directives.metadata.semanticTag` contiene l'id
 * tecnico del tag.
 *
 * I sotto-alberi Repeatable vengono saltati perché non hanno un path singolo e
 * stabile a runtime.
 */
export function collectPathsBySemanticTagId(
  sections: IEngineSection[] | null | undefined,
): Map<string, string[]> {
  const pathsBySemanticTagId = new Map<string, string[]>();

  for (const section of sections ?? []) {
    const sectionId = section.id;
    const root = section.ultimaVersione?.elementi;
    if (!sectionId || !root) continue;

    TreeNavigatorLogic.forEachNode(root, node => {
      if (node.type === WidgetType.Repeatable) {
        return true;
      }

      if (!hasCode(node) || !node.code) return;

      const semanticTagId = node.directives?.metadata?.semanticTag;
      if (!semanticTagId) return;

      // I tag semantici puntano al valore principale del widget nel form.
      const rhfPath = getWidgetPath(node, `${sectionId}.`);
      const paths = pathsBySemanticTagId.get(semanticTagId) ?? [];
      if (!paths.includes(rhfPath)) {
        paths.push(rhfPath);
      }
      pathsBySemanticTagId.set(semanticTagId, paths);
    });
  }

  return pathsBySemanticTagId;
}
